import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { SButton } from "./SButton";
import { SIcon } from "./SIcon";
const SIconButton = ({ icon, iconSize = 15, ...buttonProps })=>{
    return /*#__PURE__*/ _jsx(SButton, {
        ...buttonProps,
        className: `group w-[32px] h-[32px] !p-0 !m-0 flex items-center justify-center !bg-grayscale-dark !bg-opacity-100 rounded-md ${buttonProps.isMinimal ? "" : "border border-white/10"} ${buttonProps.className}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "transition-transform group-hover:scale-[1.1] active:scale-[0.95]",
            children: typeof icon === "string" ? /*#__PURE__*/ _jsx(SIcon, {
                type: icon,
                size: iconSize
            }) : icon
        })
    });
};
export { SIconButton };
